import React from "react"
import AlertBox from "../AlertBox/AlertBox"
import ChecklistIcon from "../ChecklistIcon/ChecklistIcon"
import Chevron from "../Chevron/Chevron"
import EditIcon from "../EditIcon/EditIcon"
import StarIcon from "../StarIcon/StarIcon"
import { BLUE } from "../../styles/colors"
import {
    Container,
    ItemRow,
    LeftSection,
    IconContainer,
    Icon,
    MultiLineInfoContainer,
    SingleLineInfoContainer,
    NameText,
    NicknameText,
    ProviderText
} from "./AccountListItem.styles"
import ProfilePicturePlaceholder from "../ProfilePicturePlaceholder/ProfilePicturePlaceholder"

export type AccountListItemProps = {
    name?: string
    nickname?: string
    noPicture?: boolean
    iconUrl: string
    accountNumber: string
    provider: string
    isValid: boolean
    oneLine?: boolean
    tag?: 'checked' | 'chevron-up' | 'chevron-down' | 'edit' | 'none'
    profilePicturePlaceholder?: string
    isFavorite?: boolean
    onFavoriteToggle?: (e: React.MouseEvent) => void
    onClick: () => void
    rightSlot?: React.ReactNode
    accountIconAltText: string
    verificationInProgressText: string
}

const AccountListItem = ({
    name,
    nickname,
    noPicture,
    iconUrl,
    profilePicturePlaceholder,
    accountNumber,
    provider,
    isValid,
    oneLine = false,
    tag = 'none',
    isFavorite,
    onFavoriteToggle,
    onClick,
    rightSlot,
    accountIconAltText,
    verificationInProgressText,
}: AccountListItemProps) => {
    return (
        <Container onClick={onClick} $isValid={isValid}>
            <ItemRow>
                <LeftSection>
                    {!noPicture && <>
                        {!profilePicturePlaceholder && <IconContainer>
                            <Icon src={iconUrl} alt={accountIconAltText} />
                        </IconContainer>}
                        {profilePicturePlaceholder && <ProfilePicturePlaceholder size={28} name={profilePicturePlaceholder} />}
                    </>}
                    {!oneLine && (
                        <MultiLineInfoContainer>
                            {name && <NameText>{name}</NameText>}
                            {nickname && <NicknameText>{nickname}</NicknameText>}
                           {provider && accountNumber && <ProviderText>{`${provider} • ${accountNumber}`}</ProviderText>}
                           {!provider && accountNumber && <ProviderText>{`${accountNumber}`}</ProviderText>}
                        </MultiLineInfoContainer>
                    )}
                    {oneLine && (
                        <SingleLineInfoContainer>
                            {name && <NameText>{`${name} - ${accountNumber}`}</NameText>}
                            {!name && <NameText>{accountNumber}</NameText>}
                        </SingleLineInfoContainer>
                    )}
                </LeftSection>
                {tag === 'checked' && <ChecklistIcon color={BLUE} size={16} />}
                {tag === 'chevron-down' && <Chevron direction="down" strokeWidth={1} color={BLUE} />}
                {tag === 'chevron-up' && <Chevron direction="up" strokeWidth={1} color={BLUE} />}
                {tag === 'edit' && <EditIcon />}
                {onFavoriteToggle !== undefined && (
                    <StarIcon
                        filled={isFavorite}
                        size={20}
                        onClick={(e) => { e.stopPropagation(); onFavoriteToggle(e); }}
                    />
                )}
                {rightSlot}
            </ItemRow>
            {!isValid && (
                <AlertBox
                    borderColor="none"
                    style={{
                        padding: 0,
                    }}
                    alertText={verificationInProgressText}
                />
            )}
        </Container>
    )
}

export default AccountListItem
